
import { defineComponent, PropType } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// @types
import { DispatcherSector } from '@/new-services/types/dispatcher-sectors'

export default defineComponent({
    components: {
        Cheap,
        TheButton,
    },
    props: {
        item: {
            type: Object as PropType<DispatcherSector>,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isCanUpdate: {
            type: Boolean,
            default: false,
        },
        isCanDelete: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['delete', 'update', 'view', 'create-extended-sector', 'update-extended-sector'],
    setup(props, { emit }) {
        const onDelete = () => {
            if (props.disabled) return
            emit('delete', { ...props.item })
        }

        const onUpdate = () => {
            if (props.disabled) return
            emit('update', { ...props.item })
        }

        const onView = () => {
            if (props.disabled) return
            emit('view', { ...props.item })
        }

        const onCreateExtendedSector = () => {
            if (props.disabled) return
            emit('create-extended-sector', { ...props.item })
        }

        const onUpdateExtendedSector = () => {
            if (props.disabled) return
            emit('update-extended-sector', { ...props.item })
        }

        return {
            onDelete,
            onUpdate,
            onView,
            onCreateExtendedSector,
            onUpdateExtendedSector
        }
    },
})
